function base64ToBlob (base64Data, contentType = '', sliceSize = 512) {
    const byteCharacters = atob(base64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}

const downloadFile = (result) => {
    const { data, headers } = result;
    let headerLine = headers && headers["content-disposition"];
    let filename = 'download';
    
    if (headerLine) {
        let startFileNameIndex = headerLine.indexOf('filename=');
        if (startFileNameIndex !== -1) {
            startFileNameIndex += 9;
            let endFileNameIndex = headerLine.lastIndexOf(';');
            if (endFileNameIndex === -1) {
                endFileNameIndex = headerLine.length;
            }
            let name = headerLine.match(/filename[^;\n]*=(UTF-\d['"]*)((['"]).*?[.]$\2|[^;\n]*)?/);
            filename = name ? decodeURI(name[0].replace("filename*=UTF-8''", '')) : headerLine.substring(startFileNameIndex, endFileNameIndex);
        }
    }

    const link = document.createElement('a');
    const blobUrl = URL.createObjectURL(new Blob([data], { type: data.type }));
    link.href = blobUrl;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(blobUrl);
}

module.exports = {
    base64ToBlob: base64ToBlob,
    downloadFile
};


// WEBPACK FOOTER //
// ./App/services/files.js